import { AppRoutes } from 'config/appRoutes';
import { alluraBigWhiteUrl, alluraSunPeaksUrl, alluraWhistlerUrl } from 'config/url';
import { hasWindow } from 'helpers/windowHelpers';
import { GuestRoutesEnum, OnboardingRoutesEnum, OwnerRoutesEnum } from 'routes/routes';

export const generateRoute = (route: string) => {
  if (hasWindow()) {
    return window.location.origin + route;
  } else {
    return '';
  }
};

export const handleTransition = (route: string) => {
  if (hasWindow()) {
    window.location.href = generateRoute(route);
  } else {
    return '';
  }
};

/** This is a temp hook to handle of our next Route transitions.
 * As of 2022-08-24, we have some serious issues with CSS
 * not loading properly when using the Next Router to transition between pages
 * Our initial quick fix will be to use the browser API to navigate instead of Next.
 */
export const userNextRouteTransitions = () => {
  const loginGuestRoute = generateRoute(AppRoutes.loginGuest);

  const loginHostRoute = generateRoute(AppRoutes.loginHost);

  const navigateToListPage = () => handleTransition(AppRoutes.list);

  const navigateToGuestLogIn = () => handleTransition(AppRoutes.loginGuest);

  const navigateToHostLogin = () => handleTransition(AppRoutes.loginHost);

  const navigateToGuestSignUp = () => handleTransition(AppRoutes.signup);

  const navigateToGuestApp = () => handleTransition(GuestRoutesEnum.home);

  const navigateToHostApp = () => handleTransition(OwnerRoutesEnum.management);

  const navigateToAlluraHome = () => (window.location.href = alluraWhistlerUrl);

  const navigateToAlluraWhistlerPage = () => (window.location.href = alluraWhistlerUrl);

  const navigateToAlluraBigWhitePage = () => (window.location.href = alluraBigWhiteUrl);

  const navigateToAlluraSunPeaksPage = () => (window.location.href = alluraSunPeaksUrl);

  const navigateToOnboarding = (property_id: number, isAssistedSetUp: boolean) =>
    (window.location.href = `${OwnerRoutesEnum.onboarding}/${property_id}${OnboardingRoutesEnum.onboardingRequired}?isAssistedSetUp=${isAssistedSetUp}&step=0`);

  return {
    generateRoute,
    handleTransition,
    loginGuestRoute,
    loginHostRoute,
    navigateToAlluraHome,
    navigateToAlluraBigWhitePage,
    navigateToAlluraSunPeaksPage,
    navigateToAlluraWhistlerPage,
    navigateToOnboarding,
    navigateToGuestApp,
    navigateToGuestLogIn,
    navigateToGuestSignUp,
    navigateToHostApp,
    navigateToHostLogin,
    navigateToListPage,
  };
};
